import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import english from "./assets/localization/en.json";
import nederlands from "./assets/localization/nl.json";
import { Language, Settings } from "./handlers/enums";

const STORAGE_KEY = "app_language";

const resources = {
    en: { translation: english },
    nl: { translation: nederlands }
};

const keys = new Set();

const resolveLanguage = () => {
    const savedLanguage = localStorage.getItem(STORAGE_KEY);
    if (savedLanguage && resources[savedLanguage]) {
        return savedLanguage;
    }

    const browserLanguage = (navigator.language || Language.English).slice(0, 2).toLowerCase();
    return resources[browserLanguage] ? browserLanguage : Language.English;
};

i18n.use(initReactI18next).init({
    resources,
    lng: resolveLanguage(),
    fallbackLng: Language.English,
    lowerCaseLng: true,
    saveMissing: true,
    interpolation: { escapeValue: false },
    missingKeyHandler: (_lngs, _ns, key) => {
        keys.add(key);
        return key;
    }
});

i18n.on("languageChanged", (language) => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
});

document.documentElement.lang = i18n.language;

let lastCount = 0;
if (Settings.TrackMissingTranslationKeys) {
    setInterval(() => {
        if (lastCount < keys.size) {
            lastCount = keys.size;
            console.warn(keys);
        }
    }, 5000);
}

export default i18n;
